angular.module('app')
  .filter('mailgunState', function () {
    return (input) => {
      switch (input) {
        case 'delivered': return 'Delivered';
        case 'permanent_fail':
        case 'temporary_fail': return 'Failed';
        case 'unsubscribed': return 'Unsubscribed';
        case 'opened': return 'Opened';
        case 'clicked': return 'Clicked';
        case 'complained': return 'Complained';
        default: return input;
      }
    };
  });
